import React from "react";
import { ToastContainer } from "react-toastify";
import ViewProductReview from "../../components/Reviews/ProductReview/ViewProductReview";

export const ViewProductReviewPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ViewProductReview />
        </div>
      </div>
    </div>
  );
};
